<template>
    <div class="main-footer">
        
    </div>
</template>

<script>

export default {
    name: 'Footer',
    components: {  }
}
</script>

<style>

</style>
